import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { TSelector } from "../../../../../i18n/types";
import DialogueCard from "../../../../../modules/onboarding/components/DialogueCard";
import { AboutQuestion, useSaveOnboardAnswer } from "../../../../../modules/onboarding/components/AboutQuestion";

const USER_MONTHLY_SALES_OPTIONS: { value: string; title: TSelector }[] = [
  { value: "0-50000", title: ($) => $.onboarding["Less than $50k"] },
  { value: "50000-250000", title: ($) => $.onboarding["$50K - $250K"] },
  { value: "250000-1000000", title: ($) => $.onboarding["$250K - $1M"] },
  { value: "1000000-25000000", title: ($) => $.onboarding["$1M - $25M"] },
  { value: "25000000+", title: ($) => $.onboarding["$25M or more"] },
];

// Takes monthly sales estimate and multiplies ranges or estimated min monthly sales by 12 months
const getAnnualSalesEstimate = (value: string) => {
  if (value.includes("-")) {
    return value
      .split("-")
      .map((n) => parseInt(n) * 12)
      .join("-");
  }

  if (value.includes("+")) {
    const numericPart = value.split("+")[0];
    return (parseInt(numericPart || "0") * 12).toString() + "+";
  }

  return "N/A";
};

function AboutSalesStep() {
  const { t } = useTranslation(["onboarding"]);
  const navigate = useNavigate();
  const saveAnswer = useSaveOnboardAnswer({ onSaved: () => void navigate({ to: "/onboarding/v2/channel" }) });

  return (
    <AboutQuestion
      prompt={t(($) => $.onboarding["Typically, what are your monthly sales?"])}
      isSaving={saveAnswer.isPending}
    >
      {USER_MONTHLY_SALES_OPTIONS.map((option) => (
        <DialogueCard
          key={option.value}
          title={t(option.title)}
          justify="center"
          onPress={() =>
            saveAnswer.mutate({
              total_monthly_sales: option.value,
              total_monthly_sales_currency: "USD",
              annual_amazon_sales: getAnnualSalesEstimate(option.value),
            })
          }
        />
      ))}
    </AboutQuestion>
  );
}

export const Route = createFileRoute("/_authenticated/onboarding/v2/about/sales")({
  component: AboutSalesStep,
});
